import {
  type CustomerNotificationsQueries,
  defCustomerNotificationsQueries,
} from '@kizen/query/customer-notifications';
import AxiosService from '__services/AxiosService';

const queries: CustomerNotificationsQueries =
  defCustomerNotificationsQueries(AxiosService);

export const customerNotificationCommentsQuery: CustomerNotificationsQueries['customerNotificationCommentsQuery'] =
  queries.customerNotificationCommentsQuery;

export const customerNotificationsInfiniteQuery: CustomerNotificationsQueries['customerNotificationsInfiniteQuery'] =
  queries.customerNotificationsInfiniteQuery;

export const customerNotificationsIndicatorQuery: CustomerNotificationsQueries['customerNotificationsIndicatorQuery'] =
  queries.customerNotificationsIndicatorQuery;

export const customerNotificationsMetadataQuery: CustomerNotificationsQueries['customerNotificationsMetadataQuery'] =
  queries.customerNotificationsMetadataQuery;
